import { useAuth } from "@/context/AuthContext";
import { Navigate } from "react-router-dom";
import { Truck } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3 text-muted-foreground">
          <Truck className="h-8 w-8 animate-pulse text-primary" />
          <span className="text-sm">Loading NTC workspace…</span>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
}
